export default __webpack_public_path__ + "static/media/page_not_found.76634210.svg";